import reduxReducerHelper, { mapDefaultValuesToActions } from '../../utils/reduxReducerHelperUtil';

import { myAppStates } from '../../hooks/useMyAppsHook';

const mappingsActions = mapDefaultValuesToActions(myAppStates);

export default reduxReducerHelper(mappingsActions, myAppStates);
